import styled, { css } from 'styled-components'

import { breakpoints } from '@/styles/breakpoints'
import { customColor } from '@/styles/custom-color'

const ContainerForMobile = css`
  padding: 0;
  max-width: 500px;
  align-self: center;

  div > p {
    font-size: 14px;
    line-height: 20px;
  }
`

export const Container = styled.div`
  display: flex;
  padding: 0 32px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  div > p {
    color: ${customColor.gray1};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  @media (max-width: ${breakpoints.xmMinWidth}) {
    ${ContainerForMobile}
  }
`
